'use client';

import { faWheelchair } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from '@mui/material';

export function IconPcd({ className = `` }) {
  return (
    <Icon
      aria-label="Vaga para pessoa com deficiência"
      className={className}
      role="img"
      style={className ? {} : { marginLeft: 14, marginRight: 14, width: 28, height: 28 }}
    >
      <FontAwesomeIcon icon={faWheelchair} style={{ color: `#373F41` }} />
    </Icon>
  );
}
